<template>
  <div class="clientele">
    <section>
      <SectionHeader title="Corporate companies"></SectionHeader>
      <div class='common__section-body clientele__client-item-container'>
        <div v-bind:key="item" class='clientele__client-item' v-for="item in corporateCompanies">
          <img :src="item">
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Industries"></SectionHeader>
      <div class='common__section-body clientele__client-item-container'>
        <div v-bind:key="item.image ? item.image : item" class='clientele__client-item' v-for="item in industries">
          <img :src="item.image ? item.image : item" v-bind:class="{'clientele__client-item-skf': item['height']}"/>
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Builders"></SectionHeader>
      <div class='common__section-body clientele__client-item-container'>
        <div v-bind:key="item" class='clientele__client-item' v-for="item in builders">
          <img :src="item">
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Govt. organisations"></SectionHeader>
      <div class='common__section-body clientele__client-item-container'>
        <div v-bind:key="item" class='clientele__client-item' v-for="item in GovtOrganisations">
          <img :src="item.image ? item.image : item" v-bind:class="{'clientele__client-item-skf': item['height']}"/>
          <!-- <img :src="item"> -->
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Hotels"></SectionHeader>
      <div class='common__section-body clientele__client-item-container'>
        <div v-bind:key="item" class='clientele__client-item' v-for="item in hotels">
          <img :src="item">
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Malls"></SectionHeader>
      <div class='common__section-body clientele__client-item-container'>
        <div v-bind:key="item" class='clientele__client-item' v-for="item in malls">
          <img :src="item">
        </div>
      </div>
    </section>
    <p class='clientele__other-organisations'>and various other leading MNC’s, Apartment Complexes, Industries & Govt. Institutions</p>
  </div>
</template>

<style lang="scss">
@import '../sass/_variables.scss';

.clientele__client-item-container {
  display: flex;
  flex-wrap: wrap;
  padding: 40px;

  @media (max-width: $md-screen) {
    padding: 0;
  }
}

.clientele__client-item {
  padding: 9px 20px 5px;
  box-shadow: 0px 2px 5px -1px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  margin: 10px;
  min-width: 140px;
  width: calc(25% - 60px);
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 180px;

    &.clientele__client-item-skf {
      height: 70px;
    }
  }
  
  @media (max-width: $md-screen) {
    height: 80px;

    img {
      height: 160px;
    }
  }
}


.clientele__other-organisations {
  text-decoration: underline;
  font-size: $fs-large;
  margin: 40px 0;
  text-align: center;
}
</style>

<script>
import SectionHeader from '@/components/sectionHeader.vue'

export default {
  name: 'clientele',
  components: {
    SectionHeader,
  },
  data: () => ({
    corporateCompanies:[
      require('../assets/images/clients/CorporateCompanies/Accenture.png')
    ],
    industries: [
      require('../assets/images/clients/industries/Siemens.png'),
      require('../assets/images/clients/industries/Himatsingka.png'),
      require('../assets/images/clients/industries/GE.png'),
      require('../assets/images/clients/industries/Bosch.png'),
      require('../assets/images/clients/industries/ABB.png'),
      require('../assets/images/clients/industries/MinoxMetals.png'),      
      require('../assets/images/clients/industries/Shahi.png'),      
      {
        image: require('../assets/images/clients/industries/Skfbearings.png'),
        height: '70px'
      }
    ],
    builders: [
      require('../assets/images/clients/builders/Ajmera.png'),
      require('../assets/images/clients/builders/Gopalan.png'),
      require('../assets/images/clients/builders/Prestige.png'),
      require('../assets/images/clients/builders/Puravankara.png'),
      require('../assets/images/clients/builders/Sobha.png')
    ],
    hotels:[
      require('../assets/images/clients/hotels/TajGroupHotels.png'),
      require('../assets/images/clients/hotels/FortuneHotels.png'),
      require('../assets/images/clients/hotels/Radisson_Blu.png')
    ],
    malls:[
      require('../assets/images/clients/malls/BmHabitatMall-Mysuru.png')
    ],
    GovtOrganisations: [
      require('../assets/images/clients/GovtOrganisations/Bescom.png'),
      require('../assets/images/clients/GovtOrganisations/IndianInstituteofAstroPhysics.png'),
      require('../assets/images/clients/GovtOrganisations/Isro.png'),
      require('../assets/images/clients/GovtOrganisations/KMF.png'),
      require('../assets/images/clients/GovtOrganisations/KPTCL.png'),
      require('../assets/images/clients/GovtOrganisations/BMTC.png')
    ]
  })
}
</script>